"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var __1 = require("..");
var styles_scss_1 = __importDefault(require("./styles.scss"));
var ToggleSwitchField = function (_a) {
    var _b;
    var _c = _a.id, id = _c === void 0 ? "" : _c, _d = _a.name, name = _d === void 0 ? "" : _d, labelText = _a.labelText, _e = _a.labelPosition, labelPosition = _e === void 0 ? "start" : _e, toggledStatus = _a.toggledStatus, onToggle = _a.onToggle, disabled = _a.disabled, reversed = _a.reversed, inline = _a.inline, fullWidth = _a.fullWidth, onFocus = _a.onFocus, onBlur = _a.onBlur;
    return (React.createElement(__1.FieldGroup, { id: "".concat(id, "-field-group"), inline: inline, automationId: "".concat(id, "-field-group"), className: (0, classnames_1["default"])(styles_scss_1["default"].container, (_b = {},
            _b[styles_scss_1["default"].fullWidth] = fullWidth,
            _b[styles_scss_1["default"].on] = toggledStatus === __1.ToggledStatus.ON,
            _b)) },
        React.createElement("div", { className: styles_scss_1["default"].inner },
            React.createElement(__1.Label, { id: "".concat(id, "-field-label"), htmlFor: "".concat(id, "-field-toggle"), automationId: "".concat(id, "-field-label"), labelText: labelText, labelType: "toggle", labelPosition: labelPosition, disabled: disabled, reversed: reversed },
                React.createElement(__1.ToggleSwitch, { id: "".concat(id, "-field-toggle"), automationId: "".concat(id, "-field-toggle"), disabled: disabled, reversed: reversed, toggledStatus: toggledStatus, name: name, onToggle: onToggle, onFocus: onFocus, onBlur: onBlur })))));
};
exports["default"] = ToggleSwitchField;
//# sourceMappingURL=ToggleSwitchField.js.map